<template>
  <span :class="{ 'code-widget-error': !data.value }"
    ><slot v-bind:value="escapedValue"></slot
  ></span>
</template>

<script>
export default {
  name: "CodeParam",
  props: {
    data: Object,
    escape: {
      type: Function,
      default: function doNothing(value) {
        return value;
      },
    },
  },
  computed: {
    isError: function () {
      return this.data.error.length != 0;
    },
    showElement: function () {
      return !this.data.optional || this.data.value;
    },
    escapedValue: function () {
      return this.escape(this.data.value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "~@/assets/less/site.less";
label.disabled,
input:disabled {
  color: @light-text;
}

input[type="text"]:disabled,
input[type="number"]:disabled,
input[type="color"]:disabled {
  background-color: @light-grey-bg;
}
</style>
